import script from "./NPCProfileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NPCProfileCard.vue?vue&type=script&setup=true&lang=js"

import "./NPCProfileCard.vue?vue&type=style&index=0&id=c36e9724&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c36e9724"]])

export default __exports__